import { BlockFillin } from 'shared-types';

type LocaleData = BlockFillin['locales'][string];

const defaultBlockData = {
  isMandatory: false,
  pointsWeight: 2,
  requireAnswerToProceed: false,
  strictEquivalence: false
};

const translatable: LocaleData['translatable'] = {
  content: '',
  feedbackCorrect: '',
  feedbackIncorrect: '',
  feedbackPartiallyCorrect: '',
  question: ''
};
const defaultLocaleData: LocaleData = { contentData: [], translatable };

const localePlaceholders = {
  content: '{{ locales.translatable.content }}' as const,
  contentData: '{{ locales.contentData }}' as const,
  correctAnswers: [],
  feedbackCorrect: '{{ locales.translatable.feedbackCorrect }}' as const,
  feedbackIncorrect: '{{ locales.translatable.feedbackIncorrect }}' as const,
  feedbackPartiallyCorrect:
    '{{ locales.translatable.feedbackPartiallyCorrect }}' as const,
  question: '{{ locales.translatable.question }}' as const
};

export const defaults = {
  defaultBlockData,
  defaultLocaleData,
  localePlaceholders
};

export const blockFillinData: BlockFillin = {
  ...defaultBlockData,
  ...localePlaceholders,
  locales: new Proxy({} as BlockFillin['locales'], {
    get: (locales, languageVersion: string) => {
      return (locales[languageVersion] = defaultLocaleData);
    }
  })
};
